import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
import { fontSize, gridSize } from '@atlaskit/theme/constants';
import { headingSizes } from '@atlaskit/theme/typography';
import { FormGrid } from '../../../common/ui/FormGrid/styled';
// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression
export var LoadingForm = styled(FormGrid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition-property: opacity;\n  transition-duration: 300ms;\n  background-color: ", ";\n  text-align: left;\n\n  opacity: ", ";\n  z-index: 1;\n  pointer-events: ", ";\n"])), "var(--ds-surface, #FFFFFF)", function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'auto' : 'none';
});
var Skeleton = styled.div({
  display: 'inline-block',
  backgroundColor: "var(--ds-skeleton, ".concat(N20, ")"),
  fontSize: "".concat(headingSizes.h200.size / fontSize(), "em"),
  borderRadius: '3px'
});
export var LabelSkeleton = styled(Skeleton)({
  width: '98px',
  marginBottom: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export var FieldSkeleton = styled(Skeleton)({
  width: '100%',
  padding: "".concat(gridSize() + 2, "px 0"),
  margin: 0,
  boxSizing: 'border-box',
  border: '2px solid transparent',
  lineHeight: '1.2em'
});